import { Observable, throwError as observableThrowError } from 'rxjs';
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import { File } from './file.model';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class FilesService {
  private _headers: any = { Accept: 'application/json' };

  constructor(private authHttpService: AuthHttpService) {}

  getFile(fileId: string): Observable<File> {
    if (fileId) {
      return this.authHttpService
        .get(Location.joinWithSlash('/files', fileId), null, this._headers)
        .pipe(
          map(({ body, ..._ }: IResponseInfo) => new File(body['file'])),
          catchError(([errorPart1, errorPart2]) =>
            observableThrowError([
              errorPart1,
              errorPart2 && errorPart2.error ? errorPart2.error : errorPart2,
            ])
          )
        );
    } else {
      return observableThrowError(
        new Error(`file id must be present. was provided: ${fileId}`)
      );
    }
  }
}
